import { ColumnsType } from "antd/es/table";
import { useMemo } from "react";
import { DATE_FORMAT } from "../../../lib/constants";
import dayjs from "../../../configs/dayjs";
import { Row } from "antd";
import { useStatusLabel } from "./useStatusLabel";
import { Email } from "../../../types/Email";
import { useReceiverCol } from "./useReceiverCol";
import { useDateLabelByPage } from "../../../components/EmailModal/hooks/useDateLabel";
import { TypeIcon } from "../components/TypeIcon";
import { TableActions } from "../components/TableActions";
import MAILING_PAGES from "../../../types/enums/MailingPages";

export const useTableColumns = (
  page: MAILING_PAGES,
  reloadData: () => void,
  setId: React.Dispatch<React.SetStateAction<string | null>>
) => {
  const { getStatusLabel } = useStatusLabel();

  const { dateLabel } = useDateLabelByPage(page);

  const { getReceiverCol } = useReceiverCol();

  const columns: ColumnsType<Email> = useMemo(() => {
    const cols = [
      {
        title: dateLabel,
        dataIndex: "date",
        key: "date",
        width: "14%",
        render: (value: string, record: any) => (
          <Row className="align-center">
            {dayjs(value).format(DATE_FORMAT)}
            <TypeIcon type={record.type} status={record.status} isRecurring={record.isRecurring} />
          </Row>
        )
      },
      {
        title: "Subject",
        dataIndex: "subject",
        key: "subject",
        width: "32%",
        ellipsis: true
      },
      {
        title: "Account",
        dataIndex: "contractNumber",
        key: "contractNumber",
        width: "13%",
        ellipsis: true
      },
      {
        title: "Receiver",
        dataIndex: "receiverName",
        key: "receiverName",
        width: "31%",
        ellipsis: true,
        render: (_: string, record: any) => {
          const { email, error } = record;

          const statusLabel = getStatusLabel(email, error);

          const value: string = getReceiverCol(record, [2, 4].includes(page));

          return (
            <Row className="justify-space-between align-center w-100">
              <Row className="d-block receiver-name">
                <p className="my-0 text-md elipsis" title={value}>
                  {value}
                </p>
                <p className="my-0 text-sm title elipsis">{email}</p>
              </Row>
              {[MAILING_PAGES.Outbox, MAILING_PAGES.Sending].includes(page) && statusLabel}
            </Row>
          );
        }
      },
      {
        title: "",
        dataIndex: "actions",
        key: "actions",
        width: page === MAILING_PAGES.Outbox ? "10%" : "5%",
        ellipsis: true,
        render: (_: any, record: any) => (
          <TableActions page={page} record={record} setId={setId} reloadData={reloadData} />
        )
      }
    ];

    return cols;
  }, [page, getStatusLabel, getReceiverCol, dateLabel, reloadData, setId]);

  return { columns };
};
